<template>
  <div>
    <template v-if="!isEmpty(selectedVideos)">
      <div class="container" v-if="isEmpty(videoSelected)">
        <div class="row">
          <category-content
            :videoInfo="video"
            v-for="video in getVideos"
            :key="video.slug"
            class="col-6 col-sm-4 col-md-3"
            @videoSelected="videoOtherClick"
          />
        </div>
      </div>
      <div class="videoList" v-else>
        <div class="container" id="videoButton">
          <button @click="backToHome">{{ $t("label.categories") }}</button>
        </div>
        <div
          class="cover d-flex align-items-center justify-content-center videoPlayer"
          v-html="getVideoSelectedPlayEmebed"
        >
          <!-- <div v-html="videoSelected.playerembed"></div> -->
          <!-- <strong>SCIENCE</strong> VIDEO -->
        </div>
        <div class="container" id="videoDetail">
          <div>
            <h3 v-html="getVideoSelectedTitle" />
            <div v-html="getVideoSelectedDesc" />
            <div v-if="!isEmpty(getVideos)">
              <div class="row">
                <category-content
                  :videoInfo="video"
                  v-for="video in getVideos"
                  :key="video.slug"
                  class="col-6 col-sm-4 col-md-4"
                  @videoSelected="videoOtherClick"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import CategoryContent from "@/components/CategoryContent.vue";
import { isEmpty, filter, includes, forEach, concat, find, get } from "lodash";
import { mapState } from "vuex";
import $ from "jquery";
export default {
  data: () => ({
    selectedVideos: [],
    videoSelected: {},
  }),
  components: {
    CategoryContent,
  },
  computed: {
    ...mapState({
      categories: "categories",
    }),
    getVideos() {
      if (!isEmpty(this.videoSelected)) {
        return filter(
          this.selectedVideos,
          (video) => video.id !== this.videoSelected.id
        );
      }
      return this.selectedVideos;
    },
    locale() {
      return this.$i18n.locale;
    },
    getVideoSelectedPlayEmebed() {
      return get(this.videoSelected, `${this.locale}.playerembed`);
    },
    getVideoSelectedTitle() {
      return get(this.videoSelected, `${this.locale}.title`);
    },
    getVideoSelectedDesc() {
      return get(this.videoSelected, `${this.locale}.description`);
    },
  },
  async created() {
    await this.doInitData();
  },
  methods: {
    isEmpty,
    videoOtherClick(videoId) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.videoSelected = find(
        this.selectedVideos,
        (item) => item.id === videoId
      );
      this.$nextTick(() => {
        let padding = "10px";
        let iframeWidth = 935;
        if (!isEmpty(this.getVideoSelectedPlayEmebed)) {
          iframeWidth = $(".videoPlayer iframe").width();
          padding = "10px 0";
        }
        if ($(window).width() >= iframeWidth) {
          padding = "inital";
        }
        $("#videoDetail").css({
          maxWidth: iframeWidth + "px",
          padding,
        });
        $("#videoButton").css({
          maxWidth: iframeWidth + "px",
          paddingBottom: "10px",
          paddingLeft: $(window).width() <= iframeWidth ? "10px" : 0,
        });
      });
    },
    backToHome() {
      this.$router.push({
        name: "Home",
        params: {
          locale: this.locale,
        },
      });
    },
    async doInitData() {
      try {
        if (isEmpty(this.categories)) {
          await this.$store.dispatch("fetchCategories", {});
        }
        //get From localstorage
        let catePlayList = [];
        try {
          const cateStored = JSON.parse(localStorage.getItem("playlist_show"));
          if (!isEmpty(cateStored)) {
            catePlayList = cateStored;
          }
        } catch (_) {
          catePlayList = [];
        }
        if (isEmpty(catePlayList)) {
          catePlayList = Cookies.get("playlist_show") || [];
        }
        if (isEmpty(catePlayList)) {
          this.backToHome();
        } else {
          let filterdVideos = [];
          forEach(this.categories, (cate) => {
            if (includes(catePlayList, cate.slug)) {
              filterdVideos = concat(filterdVideos, cate.answers);
            }
          });
          this.selectedVideos = filter(
            filterdVideos,
            (video) => !isEmpty(video)
          );
        }
      } catch (error) {
        console.error(error);
        this.backToHome();
      }
    },
  },
};
</script>
